import { EntityFilterType } from '@amzn/coral_com-amazon-carrierlogisticswebserver-model';

export const ENTITY_FILTER_ENUMS = {
  LP: EntityFilterType.LP,
  LP_TERM: EntityFilterType.LP_TERM,
  NO_FILTER: null,
};
